export default {
  app: {
    contact: 'Kérdése van? Írjon:'
  },
  menu: {
    title: {
      tableDatabase: 'Tábla adatbázis',
      map: 'Térkép',
      fertilizerDatabase: 'Műtrágya-adatbázis',
      substanceDatabases: 'Anyagok',
      applicationPlans: 'Kijuttatási tervek',
      statistics: 'Statisztika modul',
      decisionSupport: 'Döntéstámogatás',
      monitoring: 'Monitoring',
      settings: 'Beállítások',
      admin: 'Admin felület',
      home: 'Főoldal',
      advices: 'Szaktanácsadások',
      heightmap: 'Domborzati modul',
      maxiNet: 'mAXI-NET 2.0 Pozíciókövetés'
    },
    description: {
      tableDatabase: 'Adatok kezelése, rendszerezése, feltöltése',
      map: 'Adatok térképi megjelenítése, összehasonlítása',
      fertilizerDatabase: 'Tápanyagok felvitele, szerkesztése',
      advices: 'Tápanyaggazdálkodási tervek',
      applicationPlans: 'Tervek készítése, kezelése',
      monitoring: 'Időjárási és műholdi adatok elemzése',
      settings: 'Személyes adatok, jelszó módosítása',
      statistics: 'Elemzések és kimutatások készítése',
      decisionSupport: 'Előre becsült és utólagos hozam segítségével',
      heightmap: 'Táblák domborzati adatainak kezelése',
      maxiNet: 'Modem útvonalak lekérdezése'
    }
  },
  parcel: {
    offerTitle: {
      hectare: 'ha'
    },
    tab: {
      offers: 'Gazdaságok',
      groups: 'Táblacsoportok'
    },
    btn: {
      newGroup: 'Új csoport',
      uploadFiles: 'Fáljok feltöltése'
    },
    title: 'Tábla adatbázis',
    parcelCount: '{count} tábla',
    filter: {
      searchText: 'Tábla neve',
      crops: 'Növények',
      clearAll: 'Minden szűrés törlése'
    },
    toolbar: {
      title: 'Összes terület:',
      usedArea: '~{used}ha / {available}ha felhasználva',
      areaInfo:
        'Az előfizetésbe foglalt terület korlát. A feltöltött határvonal által meghatározott összevont terület alapján kerül mérésre.'
    },
    layer: {
      year: 'Év',
      name: 'Név',
      layerGroupType: 'Típus',
      date: 'Dátum'
    },
    dialog: {
      newParcelGroup: {
        title: 'Új csoport létrehozása',
        offers: {
          title: 'Gazdaságok'
        },
        groups: {
          title: 'Csoportok'
        },
        parcels: {
          title: 'Táblák',
          selectAll: 'Összes kiválasztása'
        },
        selectedParcels: {
          title: 'Kiválasztott táblák',
          deleteAll: 'Összes kiválasztott törlése',
          parcel: 'tábla',
          hectare: 'ha',
          parcelSelected: 'tábla kiválasztva',
          currentCoverage: 'Jelenlegi hozzárendelés'
        },
        createGroup: 'csoport létrehozása',
        parcel: 'tábla',
        hectare: 'ha',
        groupName: 'Csoport neve',
        filter: 'Szűrés',
        groupDetails: 'Csoport adatai',
        parcelName: 'Tábla neve',
        currentCrop: 'Adott évi növény',
        actualCropName: 'Kiválaszott növény',
        createSuccess: 'Sikeres létrehozás',
        createError: 'Sikertelen létrehozás',
        notUniqueGroupName: 'Ez a csoportnév már foglalt!',
        area: 'Terület',
        farmName: 'Gazdaság'
      },
      openLayer: {
        title: 'Táblára számított adatok'
      },
      deleteLayer: {
        title: 'Tábla adat törlése',
        text: 'Biztos, hogy törli a(z) "<strong>{name}</strong> ({year})" megnevezésű adatot?'
      },
      editLayer: {
        title: 'Tábla adat módosítása'
      },
      editParcelGroup: {
        title: 'Csoport módosítása',
        editSuccess: 'Sikeres módosítás',
        editError: 'Sikertelen módosítás',
        editGroup: 'Csoport módosítása'
      },
      removeParcelGroup: {
        title: 'Tábla törlése',
        text: 'Biztos szeretné törölni a táblát?'
      }
    },
    validation: {
      missingParcelsFromGroup: 'Kiválasztott tábla nélkül nem hozható létre a csoport!'
    },
    notifications: {
      editLayer: {
        success: 'Adatok módosítása sikeres megtörtént!',
        error: 'Hiba az adatok módosítása során!'
      },
      removeLayer: {
        success: 'Réteg sikeresen törölve!',
        error: 'Hiba a réteg törlése során!'
      }
    },
    label: {
      zones: 'Zónák',
      works: 'Munkák',
      demoOffer: 'Minta gazdaság'
    }
  },
  fertilizer: {
    label: {
      create: 'Műtrágya létrehozása',
      name: 'Név',
      nitrogen: 'Nitrogén (N)',
      phosphor: 'Foszfor (P²O⁵)',
      potassium: 'Kálium (K²O)',
      state: 'Halmazállapot',
      solid: 'Szilárd',
      liquid: 'Folyékony',
      complex: 'Komplex',
      mono: 'Mono',
      own: 'Saját',
      maximap: 'MaxiMap',
      composits: 'Összetevők',
      composition: 'Összetétel',
      creator: 'Létrehozó'
    },
    state: {
      solid: 'Szilárd',
      liquid: 'Folyékony'
    },
    btn: {
      addNew: 'Új műtrágya'
    },
    dialog: {
      delete: {
        title: 'Törlés jóváhagyása',
        text: 'Biztosan törli a műtrágyát?'
      }
    },
    validator: {
      composition: {
        invalidMessage: 'Az összetevők százalákos arányainak összege 1 és 100 közé kell hogy essen.'
      },
      name: {
        invalidMessage: 'A megadott név foglalt!'
      }
    },
    notification: {
      deleteSuccess: 'Műtrágya sikeresen törölve!',
      deleteError: 'Műtrágya törlése során hiba lépett fel!',
      createSuccess: 'Műtrágya sikeresen mentve!',
      createError: 'Műtrágya mentése során hiba lépett fel!'
    }
  },
  userProfile: {
    area: {
      limit: 'Limit',
      uploaded: 'Feltöltve',
      unused: 'Kihasználatlan'
    },
    confirm: {
      passwordChange: {
        title: 'Jelszó megváltoztatása',
        text: 'Biztosan megváltoztatja a jelszavát? Az Axial Next rendszerben is az új jelszóval fog tudni belépni a változtatás után!'
      }
    }
  },
  geoLayerUpload: {
    mapping: {
      precisionAgricultureAreaSelection: 'Alkalmas területek kiválasztása',
      deliveredDose: 'Kijuttatott dózis',
      plannedDose: 'Tervezett dózis',
      speed: 'Sebesség',
      height: 'Magasság',
      mass: 'Tömeg',
      seedWetness: 'Szemnedvesség',
      clasCellYield: 'Cellahozam',
      cellYield: 'Cellahozam',
      cellYieldRelative: 'Relatív cellahozam',
      yield: 'Cellahozam',
      deliveredStemNumber: 'Kijuttatott tőszám',
      plannedStemNumber: 'Tervezett tőszám',
      zoneStrength: 'Zónaerő',
      pH_KCL: 'pH-KCL',
      boundness: 'Kötöttség',
      allSalt: 'Összes só',
      CaCO3: 'CaCO3',
      humus: 'Humusz',
      P2O5: 'P2O5',
      K2O: 'K2O',
      NOX_N: 'NOX-N',
      Na: 'Na',
      SO42_S: 'SO42-S',
      Mn: 'Mn',
      Zn: 'Zn',
      Cu: 'Cu',
      Mg: 'Mg',
      N: 'N',
      P: 'P',
      K: 'K'
    },
    validation: {
      missingAttributeGiven: 'Legalább 1 attribútum megadása kötelező!'
    },
    infoModal: {
      title: 'Többszörös szerkesztés',
      text: 'Többszörös szerkesztés esetén csak azok a fájlból jövő attribútumok szerkeszthetőek, melyek minden fájlban benne vannak.'
    },
    dialog: {
      finalize: {
        title: 'Réteg véglegesítése',
        multipleTitle: 'Rétegek véglegesítése',
        text: 'Biztos, hogy véglegesíti a(z) "<strong>{name}</strong> ({year})" megnevezésű réteget?',
        multipleText: 'Biztos, hogy véglegesíti a(z) "{layers}" megnevezésű rétegeket?'
      },
      delete: {
        title: 'Réteg törlése',
        multipleTitle: 'Rétegek törlése',
        text: 'Biztos, hogy törli a(z) "<strong>{name}</strong> ({year})" megnevezésű réteget?',
        multipleText: 'Biztos, hogy törli a(z) "{layers}" megnevezésű rétegeket?'
      },
      info: {
        title: 'Információk a réteg feltöltésről'
      }
    },
    title: 'Beolvasott fájlok',
    layer: 'réteg',
    match: 'Egyezés:',
    attributeDifferenceModal: {
      title: 'Attribútumok'
    },
    nonMatchingWarning: {
      differentAttributes: 'A fájlok különböző attribútumokat taralmaznak! ',
      matchingAttributes: 'Közös attribútumok száma: {count}'
    },
    editStatusText: {
      editable: 'Hiányzó adatok',
      finalizable: 'Véglegesíthető',
      unmatched: 'Nincs egyezés'
    },
    processStatus: {
      editable: 'Hiányzó adatok!',
      unmatched: 'Nincs egyezés!'
    },
    status: {
      unmatched: 'Nincs egyezés',
      editable: 'Hiányzó adatok',
      finalizable: 'Véglegesíthető'
    },
    layerGroupKind: {
      zoning: 'Zónázás',
      selfZone: 'Saját zónaelhatárolás  ',
      soilSample: 'Talajminta',
      zoneStrength: 'Zónaerő',
      yield: 'Betakarítás',
      cellYield: 'Cellahozam',
      fertilizing: 'Tápanyagutánpótlás',
      pesticide: 'Növényvédelem',
      seeding: 'Vetés',
      clasCellYield: 'CLAAS Cellahozam',
      precisionAgricultureAreaSelection: 'Alkalmas területek kiválasztása',
      fertilizationPlan: 'fejtrágya',
      tillage: 'Talajművelés'
    },
    label: {
      name: 'Réteg neve',
      year: 'Év',
      layerGroupKind: 'Réteg típusa',
      disableService: 'Csak reprezentatív',
      date: 'Dátum',
      fertilizerMaterial: 'Műtrágya',
      pesticideMaterial: 'Permetszer',
      seedMaterial: 'Vetőmag'
    },
    attributeTableModal: {
      title: 'Attribútum tábla',
      addAttribute: 'Attribútum hozzáadása'
    },
    workYieldAttribute: {
      mass: 'Tömeg',
      speed: 'Sebesség',
      seedWetness: 'Szemnedvesség',
      height: 'Magasság'
    },
    workCellYieldAttribute: {
      cellYield: 'Cellahozam',
      cellYieldRelative: 'Relatív cellahozam'
    },
    workClaasCellYieldAttribute: {
      clasCellYield: 'Cellahozam'
    },
    workFertilizationAttribute: {
      deliveredDose: 'Kijuttatott dózis',
      plannedDose: 'Tervezett dózis',
      speed: 'Sebesség',
      height: 'Magasság'
    },
    workSprayingAttribute: {
      deliveredDose: 'Kijuttatott dózis',
      plannedDose: 'Tervezett dózis',
      speed: 'Sebesség',
      height: 'Magasság'
    },
    workTillageAttribute: {
      height: 'Magasság',
      speed: 'Sebesség'
    },
    workSeedingAttribute: {
      deliveredStemNumber: 'Kijuttatott tőszám / dózis',
      plannedStemNumber: 'Tervezett tőszám / dózis',
      speed: 'Sebesség',
      height: 'Magasság'
    },
    zoneStrengthAttribute: {
      zoneStrength: 'Zónaerő'
    },
    zoningAttribute: {
      zsszt: 'ZSSZT'
    },
    soilSampleAttribute: {
      pH_KCL: 'pH-KCL',
      boundness: 'Kötöttség',
      allSalt: 'Összes só',
      CaCO3: 'CaCO3',
      humus: 'Humusz',
      P2O5: 'P2O5',
      K2O: 'K2O',
      NOX_N: 'NOX-N',
      Na: 'Na',
      SO42_S: 'SO42-S',
      Mn: 'Mn',
      Zn: 'Zn',
      Cu: 'Cu',
      Mg: 'Mg'
    },
    expertAdviceAttribute: {
      N: 'N',
      P: 'P',
      K: 'K',
      Mg: 'Mg',
      Zn: 'Zn',
      Cu: 'Cu',
      Mn: 'Mn'
    },
    fertilizationPlanAttribute: {
      zoneStrength: 'Zónaerő'
    },
    precisionAgricultureAreaSelectionAttribute: {
      precisionAgricultureAreaSelection: 'Alkalmas területek kiválasztása'
    },
    classification: {
      work: 'Munka',
      zone: 'Zóna',
      plan: 'Terv'
    },
    notification: {
      editSuccess: 'Sikeres módosítás',
      editError: 'Sikertelen módosítás',
      deleteSuccess: 'Sikeres törlés',
      deleteError: 'Sikertelen törlés',
      finalizeSuccess: 'Sikeres véglegesítés',
      finalizeError: 'Sikertelen véglegesítés',
      uploadSuccess: 'Sikeres feltöltés',
      uploadError: 'Sikertelen feltöltés'
    }
  },
  button: {
    save: 'Mentés',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    cancel: 'Mégse',
    okay: 'Rendben',
    finalize: 'Véglegesítés',
    upload: 'Feltöltés',
    download: 'Letöltés',
    openAttributeTable: 'Attribútum tábla megnyitása',
    details: 'Részletek',
    next: 'Tovább',
    back: 'Vissza',
    open: 'Megnyitás',
    revert: 'Visszavonás',
    openDetails: 'Megtekintés',
    copy: 'Másolás',
    zoomToParcel: 'Táblához navigálás',
    applyPrice: 'Érték érvényesítése',
    finalizeAssignments: 'Hozzárendelések véglegesítése',
    heightmapModuleOrdered: 'Történt Domborzati csomag rendelés',
    attach: 'Csatolás',
    close: 'Bezárás',
    downloadPdfs: 'PDF-ek letöltése'
  },
  tooltip: {
    parcelBlocked:
      'A tábla blokkolva. Frissítse a mAXI-MAP előfizetés csomagját, hogy a blokkolás feloldásra kerüljön.',
    hasInclineLayers: 'A tábla nem választható, mivel már van hozzá 12%-os lejtő generálva.',
    notValidZoning: 'A táblához nem tartozik zónázás'
  },
  filter: {
    search: 'Keresés',
    status: 'Státusz',
    type: 'Típus'
  },
  notification: {
    removeSuccess: 'Sikeres törlés',
    removeError: 'Sikertelen törlés'
  },
  heightmap: {
    label: {
      heightmap: 'Útvonal táblához rendelése',
      name: 'Tábla neve',
      area: 'Terület',
      coverage: 'Lefedettség',
      newHeightmap: 'Új hozzárendelés készítése',
      detailsLoading: 'Útvonal betöltése folyamatban. Kérem várjon!',
      downloadHeightmapLayers: 'Rétegek letöltése',
      layerType: 'Réteg típus',
      infoTitle: 'Információk az útvonal hozzárendelésről',
      dataPeriod: 'Adatgyűjtés időszaka',
      fromDate: 'Kezdő dátum',
      toDate: 'Záró dátum',
      queryData: 'Adatok lekérése',
      assignedHeightmapCoverage: 'Jelenlegi hozzárendelés',
      newHeightmapCoverage: 'Új hozzárendelés',
      assignedHeightmapCoverageWarning:
        'Ez a jelenleg a táblához tárolt útvonal által lefedett terület. Az új hozzárendeléssel ez felülírásra kerül, amennyiben nagyobb a lefedési %.',
      finalizeAssignments: 'Hozzárendelések véglegesítése',
      queryLoadingText: 'Az adatok betöltése és lefedettség kalkuláció folyamatban. Kérjük türelmét.',
      particialCoverageWarning: 'Ezekhez a táblákkhoz csak részleges lefedettség tartozik',
      uncoverageWarning: 'Ezekhez a táblákhoz nincs megfelelő lefedettség',
      modem: 'Modem',
      date: 'Dátum'
    },
    layerType: {
      heightmap: 'Lefedettég és útvonal',
      twelvePercent: '12%-os lejtő',
      incline12Pct: '12%-os lejtő',
      seventeenPercent: '17%-os lejtő',
      incline17Pct: '17%-os lejtő',
      contours: 'Domborzati térkép',
      inclineContours: 'Domborzati térkép'
    },
    modal: {
      deleteTitle: 'Hozzárendelés törlése',
      deleteText: ' Biztos törli a táblához rendelt útvonalat?',
      layersDownloadModal: {
        title: 'Rétegek letöltése',
        label: {
          name: 'Tábla neve',
          area: 'Terület',
          selectAll: 'Összes kiválasztása'
        }
      },
      emptyCoverageModal: {
        title: 'Lekérés információ'
      },
      apiErrorModal: {
        title: 'Lekérés hiba'
      }
    },
    form: {
      validator: {
        greaterThan: {
          invalidMessage: 'A kezdő dátum mező értékénél nagyobbnak kell lennie.'
        },
        smallerThan: {
          invalidMessage: 'A záró dátum mező értékénél kisebbnek kell lennie.'
        },
        heightmapDataPeriodDate: {
          invalidStartDateMessage: 'A kezdő 7 nappal maximum lehet korábban, mint a záró dátum.',
          invalidEndDateMessage: 'A záró dátum maximum 7 nappal lehet később, mint a kezdő dátum.'
        }
      }
    },
    messages: {
      saveHeightmapsError: 'Hiba történt az útvonal hozzárendelés mentése során',
      saveHeightmapsSuccess: 'Az útvonal hozzárendelés sikeresen mentve'
    }
  },
  maxiNet: {
    label: {
      title: 'mAXI-NET útvonallekérdezés',
      dateRange: 'Időszak',
      settlement: 'Település',
      modem: 'Modem',
      infoTitle: 'Információ a mAXI-NET útvonallekérdezésről'
    },
    list: {
      points: 'pont'
    },
    map: {
      fullscreen: 'Teljes képernyő'
    }
  },
  plan: {
    label: {
      plan: 'Kijuttatási terv',
      plans: 'Kijuttatási tervek',
      newPlan: 'Új terv készítése',
      uploadFiles: 'Fájl feltöltés',
      downloadPlans: 'Tervek letöltése',
      noPlanSelected: 'Nincs terv kiválasztva',
      planType: 'Típus',
      dosePlan: 'Dozírozás',
      name: 'Név',
      parcelNames: 'Táblák',
      parcel: 'Tábla',
      createdAt: 'Létrehozva',
      done: 'Tervek',
      year: 'Év',
      noData: 'Nincs megjeleníthető adat',
      sumApplication: 'Tervezett össz. kijuttatás',
      realSumApplication: 'Tényleges össz. kijuttatás',
      concreteSumApplication: 'Valós össz. kijuttatás',
      sumView: 'Összesítve',
      zoneView: 'Zónánként',
      status: 'Státusz',
      attachedWork: 'Csatolt munka',
      unknown: 'Ismeretlen',
      zone: 'Zóna',
      area: 'Terület',
      fileType: 'Fájltípus',
      layers: 'Rétegek',
      parcels: 'Táblák',
      parcelUnion: 'Táblák csoportosítása',
      parcelUnionHint:
        'A kiválasztott táblák különböző csoportokba rendezhetők, amik egy közös fájlba kerülnek. Minden tábla, ami nincs egyik csoportban sem, külön fájlokba kerül.',
      parcelUnionName: 'Egyesített név',
      parcelUnionNameHint: 'Alapértelmezett név: "Táblák"',
      percentage: 'Százalékos bontás',
      percentageValue: 'Százalék',
      generateNewFile: 'Új fájlok generálása',
      ungroupedParcels: 'Önálló táblák',
      planView: 'Terv',
      workView: 'Munka',
      deltaView: 'Különbség',
      applicationRate: 'Tervezett-tényleges kijuttatás arány',
      planned: 'tervezett',
      applied: 'kijuttatott',
      delta: 'eltérés'
    },
    workDetachModal: {
      title: 'Munka leválasztása',
      text: 'Biztos le szeretné választani a {derivedFrom} munkát a tervről?',
      notification: {
        detachSuccess: 'A munka sikeresen leválasztva',
        detachError: 'Hiba történt a munka leválasztása során'
      }
    },
    workSelectorModal: {
      title: 'Munka csatolása',
      label: {
        work: 'Munka'
      },
      validator: {
        required: 'Munka kiválasztása kötelező!'
      },
      notification: {
        attachSuccess: 'A munka sikeresen csatolva',
        attachError: 'Hiba történt a munka csatolása során'
      }
    },
    planType: {
      fertilizerPlan: 'Műtrágya',
      pesticidePlan: 'Növényvédőszer',
      seedPlan: 'Vetőmag'
    },
    dosePlan: {
      zoneStrength: 'Zónaerők',
      selfZone: 'Saját zónalehatárolás',
      homogeneous: 'Homogén',
      advice: 'Szaktanácsadás'
    },
    fileType: {
      trimbleGfxTmx: 'Trimble GFX TMX',
      trimbleCfx: 'Trimble CFX',
      topcon: 'Topcon',
      shpFile: 'SHP'
    },
    messages: {
      planLoadError: 'Hiba történt a kijuttatási terv betöltése során',
      planDownloadError: 'Hiba történt a fájlok letöltése során',
      planFileGenerationError: 'Hiba történt a fájlok előállítása során',
      planFileGenerationSuccess: 'A fájlok elkészültek',
      planDownloadNoParcelSelected: 'Nincs tábla kiválasztva'
    },
    wizard: {
      step: {
        planType: 'Kijuttatandó anyag',
        dosePlan: 'Számolási módszer',
        baseSettings: 'Alapbeállítások',
        application: 'Kijuttatás',
        overview: 'Áttekintés'
      },
      label: {
        openParcels: 'Táblák megnyitása',
        openGroups: 'Csoport megnyitása',
        saveGroup: 'Csoport mentése',
        parcelSummary: '<strong>Összesen:</strong> {parcelCount} tábla, {size} ha',
        appliedNutrients: 'Kijuttott tápanyagok (max. {maxNutrients})',
        appliedPesticides: 'Kijuttott permetszerek (max. {maxNutrients})',
        appliedNutrient: 'Kijuttatandó anyag',
        problematicTables: '{problematicParcelsCount} tábla miatt nem folytatható a tervezés!',
        addNutrient: 'Tápanyag hozzáadása',
        addPesticide: 'Permetszer hozzáadása',
        addSeed: 'Vetőmag kiválasztása',
        zoning: 'Zónázás',
        advice: 'Szaktanács',
        zones: 'Zónák',
        zone: 'Zóna',
        area: 'Terület',
        nutrient: 'Tápanyag',
        pesticide: 'Permetszer',
        nutrients: 'Kijuttatandó anyagok',
        amount: 'Mennyiség',
        nitrogen: 'Nitrogén',
        phosphorus: 'Foszfor',
        potassium: 'Kálium',
        planName: 'Terv neve',
        savePlan: 'Terv mentése',
        optimization: 'Optimalizálás',
        intensity: 'Intenzitás',
        zoneStrength: 'Zónaerők',
        zoneStr: 'Zónaerő',
        groupName: 'Csoport neve',
        seed: 'Vetőmag',
        applicationPerHa: 'Kijuttatás /ha',
        applicationAll: 'Össz. kijuttatás',
        sum: 'Összesen',
        minimum: 'Minimum',
        maximum: 'Maximum',
        reverseCalculation: 'Fordított számolás'
      },
      messages: {
        loadOffersError: 'Hiba történt a táblák betöltése során',
        openParcelsError: 'Hiba történt a kiválasztott táblák megnyitása során',
        loadLayerGroupError: 'Hiba történt a kiválasztott zónák betöltése során',
        savePlanError: 'Hiba történt a kijuttatási terv mentése során',
        savePlanSuccess: 'Sikeres mentés'
      },
      advice: {
        optimizationInfo: {
          title: 'Optimalizálási információk'
        },
        optimization: {
          npk: 'Teljes (NPK)',
          np: 'Foszfor / Nitrogén (NP)',
          nk: 'Kálium / Nitrogén (NK)',
          pk: 'Foszfor / Kálium (PK)'
        },
        intenzityInfo: {
          title: 'Intenzitás információk'
        },
        intensity: {
          minimum: 'Minimum',
          environment: 'Környezetkímélő',
          scale: 'Mérlegszemléletű',
          maximum: 'Maximum'
        }
      },
      doseTypeTooltip: {
        homogeneous: 'A tábla minden részére azonos, a felhasználó által megadott dózis/tőszám kerül.',
        zoneStrength:
          '<p>A megadott kiindulási dózis/tőszám a Trimble Power Zone, vagy Axiál mAXI-Hozam által megadott zónák és zónaerők alapján kerül automatikusan differenciálásra.</p><p>Előfeltétel: ezek megléte.</p>',
        selfZone:
          'A megadott kiindulási dózis/tőszám zónánként kézzel állítható súlyozás alapján kerül differenciálásra.',
        advice:
          '<p>A dózis/tőszám a Trimble Power Zone, vagy Axiál mAXI-Hozam által megadott zónák és zónaerők, valamint az azokra vonatkozó talaj labor adatok alapján, a ProPlanta Trágyázási Szaktanácsadó rendszer által kerül meghatározásra.</p><p>Előfeltétel: ezek megléte.</p>'
      }
    },
    modal: {
      saveGroupTitle: 'Csoport mentése',
      openParcelsTitle: 'Táblák megnyitása',
      downloadFileTitle: 'Terv letöltése',
      downloadFileSuccess: 'A fájlok elkészültek, kérjük kattintson a "Letöltés" gombra.',
      downloadFilePolling: 'A fájlok készítése folyamatban...',
      deleteTitle: 'Terv törlése',
      deleteText: 'Biztos, hogy törlöd a(z) <strong>"{planName}"</strong> elnevezésű kijuttatási tervet?'
    }
  },
  statistics: {
    label: {
      statistics: 'Statisztikák',
      backToStatistics: 'Vissza a statisztikákhoz',
      detailsLoading: 'Statisztika betöltése. Sok tábla esetén ez 1-2 percet is igénybe vehet.',
      statisticsKind: 'Típus',
      name: 'Név',
      crop: 'Növény',
      parcelName: 'Tábla neve',
      parcelNames: 'Táblák',
      year: 'Vonatkozási év',
      createdAt: 'Létrehozás dátuma',
      statisticsStatus: 'Státusz',
      newStatistics: 'Új statisztika létrehozása',
      parcelView: 'Tábla nézet',
      zoneView: 'Zóna nézet',
      kind: 'Statisztika típusa',
      zoneNumber: 'Zóna #',
      area: 'Terület',
      zoneStrength: 'Zónaerő',
      zoneStrengthRank: 'Zónaerő sorrend',
      yieldRank: 'Hozam sorrend',
      delta: 'Eltérés',
      statisticsYieldValue: 'Hozam',
      yieldValue: 'Várható hozam',
      realYieldValue: 'Tényleges hozam',
      stemNumber: 'Tőszám (db/ha)',
      yieldVsStemNumber: 'Hozam / Tőszám (%)',
      yieldVsK: 'Hozam / Kálium (%)',
      yieldVsP: 'Hozam / Foszfor (%)',
      yieldVsN: 'Hozam / Nitrogén (%)',
      lowestTemperature: 'Minimum hőmérséklet (°C)',
      lowestTemperatureDate: 'Minimum hőmérséklet dátuma',
      classification: 'Besorolás',
      upkeepCost: 'Önköltség',
      cropPrice: 'Termény ár',
      estimatedRevenuePerHectare: 'Becsült haszon (/ha)',
      estimatedRevenue: 'Becsült haszon (összesen)',
      estimatedIncomePerHectare: 'Becsült bevétel (/ha)',
      estimatedIncome: 'Becsült bevétel (összesen)',
      setMedian: 'Referencia érték beállítása',
      median: 'Referencia érték',
      settedMedian: 'Beállított referencia érték',
      currentSubLayer: 'Aktuális alréteg',
      detailInfoTitle: 'Információ a statisztikáról',
      wizardInfoTitle: 'Információ a statisztika létrehozásáról',
      info: 'Statisztika modul információk',
      soilParameterName: 'Talajparaméter',
      stdBeta: 'STD. β',
      r2: 'R²',
      pValue: 'P-érték',
      n: 'N',
      strength: 'Erősség'
    },
    strength: {
      strong: 'Erős',
      medium: 'Közepes',
      weak: 'Gyenge'
    },
    tooltip: {
      stdBeta:
        'Oszlop tooltip szöveg: Standardizált regressziós együttható. Azt mutatja, hogy a talajparaméter egységnyi szórásnyi változására a hozam hány szórásnyi változással reagál. Mértékegységtől független, így a paraméterek egymással összehasonlíthatóak. Pozitív: együtt mozognak; negatív: ellentétesen.',
      r2: 'Determinációs együttható. Azt mutatja, a hozam szórásának hány százalékát magyarázza ez az egy paraméter. 0 és 1 között — minél közelebb 1-hez, annál erősebb a lineáris kapcsolat. Fontos: ez nem oksági viszony, csak együttmozgás.',
      pValue:
        'Annak a valószínűsége, hogy a kapcsolat csak véletlen műve. Kisebb érték = nagyobb a bizonyosság, hogy a kapcsolat valódi. Hagyományosan p<0.05 alatt nevezzük statisztikailag szignifikánsnak. Kis mintánál (n<15) óvatosan kezelendő.',
      n: 'Megfigyelések száma, ami jelen esetben a táblához tartozó zónák számával egyenlő.',
      strength:
        'Összesített minősítés az R², p-érték és n alapján. „Erős": R²≥0.5 és p<0.05. „Közepes": R²≥0.25 és p<0.1. „Gyenge": p>0.1 vagy R²<0.25.'
    },
    source: {
      yield: 'Hozam',
      appliedDose: 'Kijuttatott anyag',
      stemNumber: 'Tőszám',
      zoneStrength: 'Zónaerő',
      soilSample: 'Talajparaméter',
      soilTemperature: 'Talajhőmérséklet'
    },
    kind: {
      yieldAppliedDose: 'Hozam / kijuttatott tápanyag',
      yieldStemNumber: 'Hozam / tőszám',
      yieldZoneStrength: 'Hozam vs zónaerő',
      yieldSoilParameter: 'Hozam / talajparaméter',
      soilTemperature: 'Talajhőmérséklet'
    },
    status: {
      error: 'Hibás generálás',
      generating: 'Generálás alatt',
      generated: 'Elkészült'
    },
    modal: {
      deleteTitle: 'Statisztika törlése',
      deleteText: 'Biztos, hogy törlöd a(z) <strong>"{statisticsName}"</strong> elnevezésű statisztikát?',
      openParcelsTitle: 'Táblák megnyitása',
      generationErrorTitle: 'Hibás generálás',
      generationErrorText: 'A generálás során hiba történt. Kérünk jelezze az adminisztrátornak'
    },
    wizard: {
      label: {
        year: 'Év',
        statisticsType: 'Statisztika típusa',
        openParcels: 'Táblák megnyitása',
        openGroups: 'Csoport megnyitása',
        saveGroup: 'Csoport mentése',
        fromDate: 'Vetési időszak kezdete',
        toDate: 'Vetési időszak vége',
        yield: 'Hozam',
        vantageYield: 'Hozam',
        zoneStrength: 'Zónaerő',
        trimbleZoneStrength: 'Zónaerő',
        stemNumber: 'Elvetett tőszám',
        seedPlan: 'Elvetett tőszám',
        soilSample: 'Talajparaméter',
        fertilizerPlan: 'Kijuttatott tápanyag',
        appliedDose: 'Kijuttatott tápanyag',
        applyTemperatures: 'Alkalmazás az összes táblára',
        saveStatistics: 'Statisztika mentése',
        statisticsName: 'Statisztika neve',
        yearlySource: '[{year}] éves {layerGroupType}',
        yieldWarningMessage: 'Nem zóna szintű adat. Hozam mennyiség: {yieldAmount} t/ha',
        statisticsSourceYearWarningMessage: 'Korábbi éves {layerGroupType} áll csak rendelkezésre',
        sourceLayer: 'Forrás réteg',
        blockedParcel: 'Blokkolt tábla',
        sourceMissing: 'Hiányos adatforrás az táblához',
        soilSampleMissing: 'Hiányzó talajminta, vagy túl kevés zóna',
        viewBtn: {
          yield: 'Hozam megjelenítés',
          appliedDose: 'Kijuttatott anyag megjelenítés',
          stemNumber: 'Tőszám megjelenítés',
          zoneStrength: 'Zónaerő megjelenítés',
          soilSample: 'Talajparaméter megjelenítés'
        }
      },
      step: {
        start: 'Kezdés',
        source: 'Forrás',
        overview: 'Áttekintés'
      },
      dialog: {
        applyTemperatures: {
          title: 'Alkalmazás az összes táblára',
          text: 'A megadott dátumokkal minden tábla vetési dátuma felülírásra kerül.'
        }
      },
      messages: {
        saveStatisticsSuccess: 'Statisztika sikeresen mentve!',
        saveStatisticsError: 'Hiba történt a statisztika mentése során'
      }
    },
    form: {
      validator: {
        smallerThan: {
          invalidMessage: 'Korábbi dátumnak kell lennie mint a vetési időszak vége'
        },
        greaterThan: {
          invalidMessage: 'Későbbi dátumnak kell lennie mint a vetési időszak kezdete'
        },
        soilTemperaturePeriodDate: {
          invalidStartDateMessage: 'A kezdő dátum maximum 1 hónappal lehet korábban, mint a záró dátum.',
          invalidEndDateMessage: 'A záró dátum maximum 1 hónappal lehet később, mint a kezdő dátum.'
        }
      }
    },
    statisticsKind: {
      soilTemperature: 'Talajhőmérséklet',
      yieldAppliedDose: 'Hozam / Kijuttatott anyag',
      yieldSoilParameter: 'Hozam vs Talajparaméter',
      yieldStemNumber: 'Hozam / Tőszám',
      yieldZoneStrength: 'Hozam vs Zónaerő'
    },
    messages: {
      statisticLoadError: 'Hiba történt az adatok betöltése során'
    }
  },
  decisionSupport: {
    label: {
      decisionSupport: 'Döntéstámogatás',
      newDecisionSupport: 'Döntéstámogatás létrehozása',
      name: 'Név',
      crop: 'Növény',
      parcelNames: 'Táblák',
      createdAt: 'Létrehozás dátuma',
      decisionSupportStatus: 'Státusz',
      backToDecisionSupports: 'Vissza a döntéstámogatásokhoz',
      detailsLoading: 'Döntéstámogatás betöltése. Sok tábla esetén ez 1-2 percet is igénybe vehet.',
      detailInfoTitle: 'Információ a döntéstámogatásról',
      wizardInfoTitle: 'Információ a döntéstámogatás létrehozásáról'
    },
    status: {
      error: 'Hibás generálás',
      generating: 'Generálás alatt',
      generated: 'Elkészült'
    },
    modal: {
      deleteTitle: 'Döntéstámogatás törlése',
      deleteText: 'Biztos, hogy törlöd a(z) <strong>"{decisionSupportName}"</strong> elnevezésű döntéstámogatás?',
      openParcelsTitle: 'Táblák megnyitása'
    },
    wizard: {
      label: {
        chooseYear: 'Év választása',
        chooseCrop: 'Döntéstámogatás készítése az alábbi növény tábláira',
        crop: 'Választott növény',
        year: 'Választott év',
        openParcels: 'Táblák megnyitása',
        generalUpkeepCost: 'Általány önköltség',
        cropPrice: 'Termény ár',
        upkeepCost: 'Önköltség',
        source: 'Adatforrás',
        absoluteValue: 'Abszolút érték',
        sourceName: 'Hozam adatforrás neve',
        decisionSupportName: 'Döntéstámogatás neve',
        saveDecisionSupport: 'Döntéstámogatás mentése',
        sourceMissing: 'Hiányos adatforrás az táblához'
      },
      step: {
        start: 'Növény és év választása',
        source: 'Táblák kiválasztása',
        overview: 'Összesítő'
      },
      dialog: {
        applyPrice: {
          title: 'Érték érvényesítése',
          text: 'Kívánja a megadott értéket bemásolni az összes táblához? Ezzel a táblához megadott értékek felülírásra kerülnek!'
        }
      },
      messages: {
        openParcelsError: 'Hiba történt a táblák betöltése során',
        loadOffersError: 'Hiba történt a táblák betöltése során',
        saveDecisionSupportSuccess: 'Döntéstámogatás sikeresen mentve!',
        saveDecisionSupportError: 'Hiba történt a döntéstámogatás mentése során'
      }
    }
  },
  expertAdvice: {
    label: {
      parcelName: 'Tábla',
      date: 'Dátum',
      area: 'Terület',
      provider: 'Szolgáltató',
      crop: 'Növény',
      selectOne: 'Válasszon szaktanácsadást!',
      potassium: 'Kálium (kg/ha)',
      nitrogen: 'Nitrogén (kg/ha)',
      phosphor: 'Foszfor (kg/ha)',
      lime: 'Mész (kg/ha)',
      advicePlannedYield: 'Tervezett termés',
      advicePlannedYieldUnit: 'Tervezett termés (t/ha)',
      year: 'Év'
    },
    adviceType: {
      precision: {
        title: 'Precíziós szaktanácsadás'
      },
      parcel: {
        title: 'Tábla szintű szaktanácsadás'
      }
    }
  },
  errorPage: {
    title: '404',
    description: 'A keresett oldal nem található',
    homeBtn: 'Vissza a főoldalra'
  },
  monitoring: {
    info: {
      title: 'Indexek'
    },
    weatherForecast: {
      title: 'Időjárás előrejelzés'
    },
    satelliteImages: {
      title: 'Műholdképek'
    },
    monitoringType: {
      advanced: {
        title: 'Összetett',
        description: 'Több tábla adatainak összehasonlítása'
      },
      tables: {
        title: 'Táblák',
        description: 'Szolgáltatás aktivitása táblákra'
      },
      simple: {
        title: 'Egyszerű',
        description: 'Táblák statisztikai adatainak megjelenítése'
      }
    },
    notification: {
      selectParcelsError: 'Hiba történt a táblák betöltése során',
      activateParcelsError: 'Hiba történt a táblák aktiválása során'
    },
    title: 'Monitoring',
    subtitle: 'Aktív táblák',
    btn: {
      activateTables: 'Táblák aktiválása',
      compare: 'Összehasonlítás'
    },
    quickFilter: {
      oneWeek: '1 hétre visszamenőleg',
      oneMonth: '1 hónapra visszamenőleg',
      threeMonth: '3 hónapra visszamenőleg',
      halfYear: 'Fél évre visszamenőleg',
      oneYear: '1 évre visszamenőleg'
    },
    weatherType: {
      'clear sky': 'Tiszta égbolt',
      'few clouds': 'Kevés felhő (11-25%)',
      'scattered clouds': 'Elszórtan felhős (25-50%)',
      'broken clouds': 'Felszakadozot felhőzet (51–84%)',
      'shower rain': 'Zápor',
      rain: 'Eső',
      thunderstorm: 'Zivatar',
      snow: 'Hó',
      mist: 'Ködfátyol',
      'thunderstorm with light rain': 'Zivatar enyhe esővel',
      'thunderstorm with rain': 'Zivatar esővel',
      'thunderstorm with heavy rain': 'Zivatar heves esőzéssel',
      'light thunderstorm': 'Enyhe zivatar',
      'heavy thunderstorm': 'Erős zivatar',
      'ragged thunderstorm': 'Zivatar foltok',
      'thunderstorm with light drizzle': 'Zivatar enyhe szitálással',
      'thunderstorm with drizzle': 'Zivatar szitálással',
      'thunderstorm with heavy drizzle': 'Zivatar, erős szitálás',
      'light intensity drizzle': 'Kis intenzitású szitálás',
      drizzle: 'Szitálás',
      'heavy intensity drizzle': 'Erős intenzitású szitálás',
      'light intensity drizzle rain': 'Kis intenzitású szitáló eső',
      'drizzle rain': 'Szitáló eső',
      'heavy intensity drizzle rain': 'Erős intenzitású szitáló eső',
      'shower rain and drizzle': 'Zápor és szitálás',
      'heavy shower rain and drizzle': 'Heves zápor és szitálás',
      'shower drizzle': 'Zápor szitálás',
      'light rain': 'Enyhe eső',
      'moderate rain': 'Mérsékelt esőzés',
      'heavy intensity rain': 'Heves esőzés',
      'very heavy rain': 'Nagyon heves esőzés',
      'extreme rain': 'Extrém esőzés',
      'freezing rain': 'Ónos eső',
      'light intensity shower rain': 'Könnyű zápor',
      'heavy intensity shower rain': 'Heves zápor',
      'ragged shower rain': 'Zápor foltok',
      'light snow': 'Enyhe havazás',
      Snow: 'Hó',
      'Heavy snow': 'Erős havazás',
      Sleet: 'Havas eső',
      'Light shower sleet': 'Enyhe havas eső',
      'Shower sleet': 'Havas zápor',
      'Light rain and snow': 'Enyhe eső és hó',
      'Rain and snow': 'Eső és hó',
      'Light shower snow': 'Könnyű hó zápor ',
      'Shower snow': 'Hózápor',
      'Heavy shower snow': 'Erős hózápor',
      Smoke: 'Füst',
      Haze: 'Pára',
      'sand/ dust whirls': 'Homok / por örvény',
      fog: 'Köd',
      sand: 'Homok',
      dust: 'Por',
      'volcanic ash': 'Vulkanikus hamu',
      squalls: 'Viharos szél',
      tornado: 'Tornádó',
      'overcast clouds': 'Borús égbolt (85-100%)'
    },
    messages: {
      loadingError: 'Hiba történt a betöltés során.',
      imageLoadingError: 'Hiba történt a kép betöltése során',
      parcelLoadingError: 'Hiba történt a táblák betöltése során',
      satelliteImagesLoadingError: 'Hiba történt a polygon műholdkép adatainak betöltése során',
      weatherHistoryLoadingError: 'Hiba történt a polygon időjárás adatainak betöltése során',
      ndviLoadingError: 'Hiba történt a polygon NDVI adatainak betöltése során',
      soilLoadingError: 'Hiba történt a polygon talaj adatainak betöltése során',
      weatherForecastLoadingError: 'Hiba történt a polygon időjárás előrejelzés adatainak betöltése során'
    },
    noData: 'Nincs megjeleníthető adat',
    label: {
      maxClouds: 'Max. felhősség',
      clouds: 'Felhősség',
      avg: 'Átlag',
      median: 'Medián',
      min: 'Minimum',
      max: 'Maximum',
      update: 'Frissítés',
      temperature: 'Hőmérséklet',
      rain: 'Csapadék',
      groundTemperature: 'Talajhőmérséklet',
      surfaceGroundTemperature: 'Felületi talajhőm.',
      groundTemperature10cm: 'Talajhőm. 10cm mélyen',
      weather: 'Időjárás',
      moisture: 'Nedvesség',
      NDVI: 'NDVI',
      sync: 'Szinkron',
      syncTooltip: 'Minden polygon műholdképének szinkronizált váltása'
    }
  },
  map: {
    layerHintGroupMode: {
      isolated: 'Izolált',
      merged: 'Összesített'
    },
    advancedSettings: 'Haladó beállítások',
    classification: 'Osztályozás',
    layout: 'Elrendezés',
    mapSettings: 'Térkép beállítások',
    isolated: 'Izolált',
    isolatedDescription: 'Minden rétegre külön osztályozás a saját min-max értékei alapján',
    summarized: 'Összesített',
    summarizedDescription: 'Egy átfogó osztályzás az összes azonos típusú rétegre',
    layers: 'Rétegek',
    map: 'Térkép',
    automaticRotation: 'Automatikus rotáció',
    parcelsData: 'Tábla adatok',
    plans: 'Kijuttatási tervek',
    jumpToScale: 'Terjedelemre ugrás',
    downloadLayerGroup: 'Letöltés',
    subLayers: 'Alrétegek',
    opacity: 'Átlátszóság',
    legend: 'Jelmagyarázat',
    removeLayer: 'Réteg törlése',
    removeAllLayers: 'Összes réteg törlése',
    addedLayers: 'Hozzáadott rétegek',
    showTables: 'Táblák megjelenítése',
    addLayer: 'Réteg hozzáadása',
    layer: 'Réteg',
    parcelBorder: 'Táblahatár'
  },
  pesticide: {
    label: {
      name: 'Név',
      unitType: 'Mértékegység',
      creator: 'Létrehozó',
      own: 'Saját',
      maximap: 'mAXI-MAP'
    },
    filter: {
      searchText: 'Keresés'
    },
    btn: {
      addNew: 'Új permetszer'
    },
    details: {
      title: 'Új permetszer létrehozása'
    },
    dialog: {
      delete: {
        title: 'Permetszer törlése',
        text: 'Biztosan törli a permetszert?'
      }
    },
    notification: {
      deleteSuccess: 'Permetszer sikeresen törölve!',
      deleteError: 'Permetszer törlése során hiba lépett fel!',
      saveSuccess: 'Permetszer sikeresen mentve!',
      saveError: 'Permetszer mentése során hiba lépett fel!'
    },
    validator: {
      name: {
        invalidMessage: 'A megadott név foglalt!'
      }
    }
  },
  substanceDatabases: {
    fertilizersTab: 'Műtrágya-adatbázis',
    pesticidesTab: 'Permetszer-adatbázis',
    seedsTab: 'Vetőmag-adatbázis'
  },
  seed: {
    label: {
      name: 'Név',
      unitType: 'Mértékegység'
    }
  }
};
